import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, defer, from, map, switchMap, throwError } from 'rxjs'
import { userActions } from './user.actions'
import { Router } from '@angular/router'
import { ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT } from '../../shared/constants/router-state-keys'
import { AuthApiService } from '../../shared/services/auth-api.service'
import { ToasterService } from '../../shared/services/toaster.service'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable()
export class UserEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly router: Router,
        private readonly auth: AuthApiService,
        private readonly toaster: ToasterService
    ) {}

    userLoggingOut$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(userActions.logoutViewerStateSent),
            switchMap(() =>
                this.auth.logout().pipe(
                    catchError((err: HttpErrorResponse) => {
                        this.toaster.httpError(err, 'Error logging out.')
                        return throwError(() => err)
                    })
                )
            ),
            map(() => userActions.logoutFinished())
        )
    })

    userLoggedOut$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(userActions.logoutFinished),
                switchMap(() =>
                    defer(() =>
                        from(
                            this.router.navigate(['/login'], {
                                state: { [ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT]: true },
                            })
                        )
                    )
                )
            )
        },
        { dispatch: false }
    )
}
